import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Key = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M8.68195 7.62135L3.03033 1.96973L1.96967 3.03039L2.93934 4.00006L1.46967 5.46973L2.53033 6.53039L4 5.06072L4.93934 6.00006L3.46967 7.46973L4.53033 8.53039L6 7.06072L7.62129 8.68201C7.22865 9.27484 7 9.98575 7 10.7501C7 12.8211 8.67893 14.5001 10.75 14.5001C12.8211 14.5001 14.5 12.8211 14.5 10.7501C14.5 8.67899 12.8211 7.00006 10.75 7.00006C9.98568 7.00006 9.27478 7.22871 8.68195 7.62135ZM13 10.7501C13 11.9927 11.9926 13.0001 10.75 13.0001C9.50735 13.0001 8.5 11.9927 8.5 10.7501C8.5 9.50742 9.50735 8.50006 10.75 8.50006C11.9926 8.50006 13 9.50742 13 10.7501Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Key;
